var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQwincy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42023 4.35553C10.0102 -1.23088 19.0688 -1.23088 24.658 4.35553C26.5506 6.24695 27.8747 8.63137 28.4802 11.2379C29.0856 13.8444 28.948 16.5685 28.083 19.1007C27.7083 20.209 27.1966 21.266 26.5598 22.2473L24.1553 19.841L13.3778 9.06114L15.7134 6.72437L25.379 16.3921C25.7862 14.0859 25.4476 11.71 24.4124 9.60952C23.3771 7.50903 21.6993 5.79342 19.6225 4.71198C17.5458 3.63053 15.1784 3.23958 12.8644 3.59595C10.5503 3.95231 8.41014 5.03742 6.75482 6.6936C5.0995 8.34978 4.01529 10.4908 3.65971 12.8054C3.30413 15.1201 3.69571 17.4879 4.77756 19.5647C5.85941 21.6416 7.57516 23.3193 9.67551 24.3541C11.7759 25.3889 14.1514 25.7269 16.4569 25.3189L13.3778 22.2391L15.7134 19.9031L22.3075 26.4985C21.3262 27.1359 20.2691 27.6481 19.1608 28.0234C16.6291 28.8858 13.9066 29.0221 11.3014 28.4168C8.6963 27.8115 6.3126 26.4888 4.42023 24.5984C-1.1677 19.0072 -1.16975 9.94194 4.42023 4.35553ZM13.0658 15.4178L26.2328 28.7889H30.9999L15.449 12.997L13.0658 15.4178Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQwincy);
export default __webpack_public_path__ + "static/media/qwincy.efa4a39d0c942d50067fb1f8a0551dc7.svg";
export { ForwardRef as ReactComponent };